import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 738 516"
      width={738}
      height={516}
      {...props}
    >
      <style>
        {
          ".prefix__shp2{fill:#fff}.prefix__shp5{fill:#8e8e8e}.prefix__shp6{fill:#000}"
        }
      </style>
      <g id="prefix__\\\\321\\\\353\\\\356\\\\351_1">
        <g id="prefix__&lt;Group&gt;">
          <g id="prefix__&lt;Group&gt;">
            <path
              id="prefix__&lt;Path&gt;"
              d="M637.19 444.98H94.45c-25.36 0-46.1-20.74-46.1-46.1V105.47c0-25.36 20.74-46.11 46.1-46.11h542.74c25.36 0 46.1 20.75 46.1 46.11v293.41c0 25.36-20.74 46.1-46.1 46.1z"
              fill="#d1dce5"
            />
          </g>
          <g id="prefix__&lt;Group&gt;">
            <path
              id="prefix__&lt;Path&gt;"
              d="M683.29 208.96H48.35v-79.79h634.94v79.79z"
              fill="#5d5d5d"
            />
          </g>
          <g id="prefix__&lt;Group&gt;">
            <path
              id="prefix__&lt;Path&gt;"
              className="prefix__shp2"
              d="M634.67 389.51H97.38V257.78h537.29v131.73z"
            />
          </g>
          <path
            id="prefix__&lt;Path&gt;"
            d="M699.58 328.75c0 36.31-13.18 69.51-35.06 95.1-26.88 31.45-66.83 51.38-111.42 51.38-44.61 0-84.56-19.93-111.41-51.38-21.89-25.59-35.09-58.79-35.09-95.1 0-34.26 11.76-65.76 31.45-90.71 26.81-33.98 68.39-55.8 115.05-55.8 46.67 0 88.22 21.82 115.05 55.8 19.7 24.95 31.43 56.45 31.43 90.71z"
            fill="#e6eef4"
          />
          <path
            id="prefix__&lt;Path&gt;"
            className="prefix__shp2"
            d="M699.58 328.75c0 36.31-13.18 69.51-35.06 95.1H441.69c-21.89-25.59-35.09-58.79-35.09-95.1 0-34.26 11.76-65.76 31.45-90.71h230.1c19.7 24.95 31.43 56.45 31.43 90.71z"
          />
          <path
            id="prefix__&lt;Compound_Path&gt;"
            fillRule="evenodd"
            d="M712.24 328.75c0 37.07-13.24 72.97-37.28 101.08-29.65 34.7-72.81 54.6-118.41 54.6-45.62 0-88.78-19.9-118.41-54.61-24.05-28.12-37.3-64.01-37.3-101.07 0-35.37 11.57-68.71 33.44-96.41 29.73-37.69 74.29-59.3 122.27-59.3 47.96 0 92.53 21.61 122.28 59.3 21.85 27.68 33.41 61.01 33.41 96.41zm-51.27 89.12c21.19-24.78 32.86-56.43 32.86-89.12 0-31.21-10.18-60.61-29.45-85-26.24-33.24-65.54-52.3-107.83-52.3-42.31 0-81.61 19.06-107.82 52.29-19.28 24.42-29.48 53.82-29.48 85.01 0 32.67 11.68 64.32 32.88 89.12 26.13 30.6 64.19 48.16 104.42 48.16 40.21 0 78.27-17.56 104.42-48.16z"
            fill="#ec6250"
          />
          <g id="prefix__&lt;Group&gt;">
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                fillRule="evenodd"
                className="prefix__shp5"
                d="M164.29 347.52v-43.33h25.99v43.33h-25.99zm17.33-34.66h-8.67v26h8.67v-26z"
              />
            </g>
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                className="prefix__shp5"
                d="M215.41 347.52v-34.66h-8.67v-8.67h17.33v43.33h-8.66z"
              />
            </g>
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                fillRule="evenodd"
                className="prefix__shp5"
                d="M240.79 347.52v-43.33h25.99v43.33h-25.99zm17.33-34.66h-8.67v26h8.67v-26z"
              />
            </g>
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                className="prefix__shp5"
                d="M291.91 347.52v-34.66h-8.66v-8.67h17.33v43.33h-8.67z"
              />
            </g>
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                fillRule="evenodd"
                className="prefix__shp5"
                d="M317.29 347.52v-43.33h25.99v43.33h-25.99zm17.33-34.66h-8.67v26h8.67v-26z"
              />
            </g>
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                className="prefix__shp5"
                d="M368.41 347.52v-34.66h-8.66v-8.67h17.33v43.33h-8.67z"
              />
            </g>
          </g>
          <g id="prefix__&lt;Group&gt;">
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                className="prefix__shp6"
                d="M472.09 366.1v-64.38H456v-16.1h32.19v80.48h-16.1z"
              />
            </g>
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                className="prefix__shp6"
                d="M519.23 366.1v-48.28h32.18v-16.1h-32.18v-16.1h48.27v48.3h-32.18V350h32.18v16.1h-48.27z"
              />
            </g>
            <g id="prefix__&lt;Group&gt;">
              <path
                id="prefix__&lt;Compound_Path&gt;"
                className="prefix__shp6"
                d="M597.05 366.1V350h32.19v-16.08h-16.1v-16.1h16.1v-16.1h-32.19v-16.1h48.28v80.48h-48.28z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
